<template>
  <g>
    <!-- Flower ornament centered at top of opening -->
    <svg v-for="ornament in ornaments" :key="ornament.key"
      :x="ornament.x" :y="ornament.y"
      :width="ornamentWidth" :height="ornamentHeight"
      viewBox="0 0 90.5 46.19"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <g>
          <g>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M41.77,6.11c0-3.24,3.48-5.86,3.48-5.86,0,0,3.48,2.62,3.48,5.86l-3.48,39.83-3.48-39.83Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M5.42,42.46c-3.19-.56-5.17-4.45-5.17-4.45,0,0,3.19-2.98,6.38-2.41l38.62,10.35-39.83-3.48Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M55.6,7.32c1.11-3.04,5.28-4.32,5.28-4.32,0,0,2.38,3.66,1.27,6.7l-16.9,36.24L55.6,7.32Z"/>
          </g>
          <g>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M9.01,29.05c-2.8-1.62-3.33-5.95-3.33-5.95,0,0,4.02-1.71,6.82-.09l32.75,22.93L9.01,29.05Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M68.18,13.19c2.08-2.48,6.44-2.25,6.44-2.25,0,0,.98,4.25-1.1,6.73l-28.27,28.27,22.93-32.75Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M16.98,17.67c-2.08-2.48-1.1-6.73-1.1-6.73,0,0,4.36-.23,6.44,2.25l22.93,32.75-28.27-28.27Z"/>
          </g>
          <g>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M78,23.01c2.8-1.62,6.82.09,6.82.09,0,0-.53,4.33-3.33,5.95l-36.24,16.9,32.75-22.93Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M28.35,9.71c-1.11-3.04,1.27-6.7,1.27-6.7,0,0,4.17,1.27,5.28,4.32l10.35,38.62L28.35,9.71Z"/>
            <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" d="M83.87,35.6c3.19-.56,6.38,2.41,6.38,2.41,0,0-1.98,3.89-5.17,4.45l-39.83,3.48,38.62-10.35Z"/>
          </g>
        </g>
        <polyline fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" points="45.25 .25 45.25 45.94 29.62 3.01"/>
        <polyline fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" points="74.62 10.94 45.25 45.94 60.88 3.01"/>
        <polyline fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" points="84.82 23.1 45.25 45.94 90.25 38.01"/>
        <line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" x1="45.25" y1="45.94" x2=".25" y2="38.01"/>
        <polyline fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" points="15.88 10.94 45.25 45.94 5.68 23.1"/>
        <line fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width=".5" x1=".25" y1="45.94" x2="90.25" y2="45.94"/>
      </g>
    </svg>
  </g>
</template>

<script>
// Rendered width of the ornament (in inches)
const ORNAMENT_WIDTH = 1.25;
// Rendered height of the ornament (in inches)
const ORNAMENT_HEIGHT = 0.63;
// Distance from the top edge of the opening to the bottom edge of the ornament (in inches)
const GAP_TO_OPENING = 0;

export default {
  props: {
    artworkOpenings: {
      type: Array,
      required: true
    }
  },
  computed: {
    ornamentWidth() {
      return ORNAMENT_WIDTH;
    },
    ornamentHeight() {
      return ORNAMENT_HEIGHT;
    },
    ornaments() {
      return this.artworkOpenings.map((opening) => {
        // Center horizontally above the bevel
        const centerX = opening.bevelX + (opening.bevelWidth / 2);
        const x = centerX - (ORNAMENT_WIDTH / 2);
        // The bevel stroke extends outward from the bevel rect, so we need to account for
        // the full stroke width. bevelY is the rect edge, but the visible top of the bevel
        // is bevelWidth/2 above that (since stroke is centered on the rect edge).
        const bevelStrokeWidth = (opening.y - opening.bevelY) * 2;
        const visibleBevelTop = opening.bevelY - (bevelStrokeWidth / 2);
        const y = visibleBevelTop - GAP_TO_OPENING - ORNAMENT_HEIGHT;

        return { key: `${opening.key}-flower`, x, y };
      });
    }
  }
};
</script>
